import React from "react";
import GameMap from "./logic/GameMap";
import { mapConfigs } from "./MapConfig/mapConfigs";

export default function MyIsland() {
  React.useEffect(() => {
    document.title = "My Island | Pokémon Radiance";
  }, []);

  return <GameMap config={mapConfigs.myisland} />;
}
